@let config = resolvedConfig();
<app-modal-filler-atom [index]="(index$ | async) ?? 0"></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 mx-auto shadow md:left-0 md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center"
  [ngClass]="(isMobile$ | async) ? 'max-w-screen-sm' : ''"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [style.max-height]="
    availableHeight ? availableHeight + 'px' : (isMobile$ | async) ? '85vh' : null
  "
  [class.bottom-0]="keyboardOffset === 0 && (isMobile$ | async)"
>
  @if (settingsSelector.selectDeviceIsDesktopScreen | async) {
    <app-modal-filler-atom
      [withBackdrop]="false"
      [index]="(index$ | async) ?? 0"
    ></app-modal-filler-atom>
  }
  <div
    class="overflow-y-auto rounded-t-3xl p-5 md:max-w-lg md:rounded-3xl md:p-7"
    [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
    [style.z-index]="((index$ | async) ?? 0) + 50"
    [style.max-height]="
      availableHeight ? availableHeight - 20 + 'px' : (isMobile$ | async) ? '85vh' : null
    "
  >
    @if (!user?.[userKeys.Id] || !user?.[userKeys.Email]) {
      <div>
        <app-authentication-block
          [userJourneyType]="resolveUserJourneyType(config.user_journey_type)"
          [legalCheckboxLabel]="config.legal_checkbox_label"
          [optinCheckboxLabel]="config.optin_checkbox_label"
          [firstStepHeading]="config.first_step_heading"
          [firstStepLoginButton]="config.first_step_login_button"
          [firstStepSignupButton]="config.first_step_signup_button"
          [loginStepHeading]="config.login_step_heading"
          [signupStepHeading]="config.signup_step_heading"
          [signupStepSubheading]="config.signup_step_subheading"
          [signupStepDisplayFirstname]="config.signup_step_display_firstname"
          [signupStepFirstnameLabel]="config.signup_step_firstname_label"
          [signupStepFirstnameHelp]="config.signup_step_firstname_help"
          [signupStepDisplayLastname]="config.signup_step_display_lastname"
          [signupStepLastnameLabel]="config.signup_step_lastname_label"
          [signupStepLastnameHelp]="config.signup_step_lastname_help"
          [signupStepEmailLabel]="config.signup_step_email_label"
          [signupStepEmailHelp]="config.signup_step_email_help"
          [signupStepDisplayPhone]="config.signup_step_display_phone"
          [signupStepPhoneLabel]="config.signup_step_phone_label"
          [signupStepPhoneHelp]="config.signup_step_phone_help"
          [signupStepPasswordLabel]="config.signup_step_password_label"
          [signupStepPasswordHelp]="config.signup_step_password_help"
          [signupFooter]="signupFooter()"
          [authenticationProviderGoogle]="config.authentication_provider_google"
          [authenticationProviderFacebook]="config.authentication_provider_facebook"
          [authenticationProviderApple]="config.authentication_provider_apple"
          [cgvUrl]="config.cgv_url"
          [privacyPolicyUrl]="config.privacy_policy_url"
          [legalNoticeUrl]="config.legal_notice_url"
        ></app-authentication-block>
      </div>
    }
    @if (user?.[userKeys.Id] && user?.[userKeys.Email]) {
      <div>
        <p class="mb-7 mt-5 font-base text-neutral-600">
          {{ 'authentication.already-logged-in.already-logged-in-as-user' | translate: user }}
        </p>
        <div class="flex items-center justify-between pt-1">
          <div class="mr-2 w-full xm:w-1/2 xm:pr-1">
            <app-button-atom
              size="M"
              [label]="'authentication.already-logged-in.cancel-button' | translate"
              color="primary"
              (click)="close()"
              type="light"
              [full]="true"
            ></app-button-atom>
          </div>
          <div class="w-full xm:w-1/2 xm:pl-1">
            <app-button-atom
              size="M"
              [label]="'authentication.already-logged-in.logout-button' | translate"
              (click)="logout()"
              type="primary"
              [full]="true"
            ></app-button-atom>
          </div>
        </div>
      </div>
    }
  </div>
</div>
